// Login.jsx
import React, { useState, useRef } from 'react';
import logo from '../assests/Logo-Tabsons-India.png';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { useAuth } from './context/AuthContext'; // Adjust the import path as needed

function Login() {
    const navigate = useNavigate();
    const toast = useRef(null);
    const [checked, setChecked] = useState(false);
    const [form, setForm] = useState({
        email: '',
        password: '',
    });
    const [errors, setErrors] = useState({});
    const { login } = useAuth();

    const validateForm = () => {
        let hasErrors = false;
        let newErrors = {};

        if (form.email === '') {
            hasErrors = true;
            newErrors.email = 'Email is required.';
        }
        if (form.password === '') {
            hasErrors = true;
            newErrors.password = 'Password is required.';
        }
        setErrors(newErrors);
        return !hasErrors;
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/login/`, {
                    method: 'POST',
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: form.email,  
                        password: form.password
                    })
                });

                if (!response.ok) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Invalid credentials.' });
                    throw new Error('Invalid credentials');
                }

                const data = await response.json();
                // localStorage.setItem('username', data.user.username); // Save username to local storage
                if(data.user.first_login == false){
                  navigate('/changepassword', { state: { userId: data.user.id } });
                }else{
                    login(data.user); // Save userID to context
                    navigate('/home');
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Login successful' });
                }
                
                
            } catch (error) {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'An error occurred' });
            }
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    return (
        <div>
            <Toast ref={toast} />
            <div className="flex align-items-center justify-content-center min-h-screen">
                <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
                    <div className="text-center mb-5">
                        <img src={logo} alt="hyper" height={50} className="mb-3" />
                        <div className="text-900 text-3xl font-medium mb-3">Welcome Back</div>
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-900 font-medium mb-2">Email</label>
                        <InputText
                            id="email"
                            type="text"
                            placeholder="Email address"
                            className={`w-full ${errors.email ? '' : 'mb-3'}`}
                            value={form.email}
                            onChange={handleInputChange}
                        />
                        {errors.email && <small className="p-error block mb-3">{errors.email}</small>}

                        <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
                        <InputText
                            id="password"
                            type="password"
                            placeholder="Password"
                            className={`w-full ${errors.password ? '' : 'mb-3'}`}
                            value={form.password}
                            onChange={handleInputChange}
                        />
                        {errors.password && <small className="p-error block mb-3">{errors.password}</small>}

                        <div className="flex align-items-center justify-content-between mb-6">
                            <div className="flex align-items-center">
                                <Checkbox
                                    id="rememberme"
                                    onChange={(e) => setChecked(e.checked)}
                                    checked={checked}
                                    className="mr-2"
                                />
                                <label htmlFor="rememberme">Remember me</label>
                            </div>
                            <a className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer" onClick={() => navigate('/forgotpassword')}>Forgot your password?</a>
                        </div>

                        <Button label="Sign In" icon="pi pi-user" className="w-full" onClick={handleSubmit} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
